import { AfterViewInit, Component, Input } from '@angular/core';
import { WhiskeyItem } from '../../menu.model'

@Component({
  selector: 'japanese',
  templateUrl: './japanese.component.html',
  styleUrls: ['./japanese.component.scss']
})
export class JapaneseComponent implements AfterViewInit {

  @Input() whiskeyList: Array<WhiskeyItem> = [];
  @Input() activeSection: string | undefined;

  constructor() {}

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

}
